import React from 'react';
import PropTypes from 'prop-types';
import Bem from './packages/honey-bem.js';
import { Injecss } from './packages/injecss.js';

var styles = {
raw: ".hcr-label-1-6-0{display:block;position:absolute;top:-8px;left:7px;padding:1px 5px;border-radius:5px;background:#fff;color:#444;font-family:Roboto Condensed,Arial,sans-serif;font-size:14px;font-weight:300;line-height:1em;text-align:left;z-index:1}@media (min-width:1200px){.hcr-label-1-6-0{position:static;top:auto;left:auto;padding:0 0 2px;background:transparent;color:#757575;font-size:16px;line-height:1.375em}}",
map:{"hcr-label":"hcr-label-1-6-0"}};

var Label = function Label(_ref) {
  var text = _ref.text,
      labelFor = _ref.labelFor,
      extraClasses = _ref.extraClasses,
      requiredText = _ref.requiredText;
  // defines base block class name for the input
  var bem = Bem('label', styles); // stores BEM class names, defines BEM modifiers

  var labelText = requiredText ? "".concat(text, " (").concat(requiredText, ")") : text;
  return React.createElement("label", {
    className: bem.b(false, extraClasses),
    htmlFor: labelFor
  }, labelText);
};
Label.displayName = 'Label';
Label.defaultProps = {
  extraClasses: '',
  labelFor: null,
  requiredText: null
};
Label.propTypes = {
  /** Text for a label */
  text: PropTypes.string.isRequired,

  /** Specifies for attribute, should have an ID of associated input */
  // @todo this needs to be required for a11y purposes,
  // reconsider approach in SelectGroup and TimeInput components
  labelFor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Marks the element as required, adds specified text to label text,
   * e.g. Phone (Mandatory) for required="(Mandatory)" */
  requiredText: PropTypes.string,

  /** Custom classes name for tooltip element */
  extraClasses: PropTypes.string
};
var Label$1 = Injecss(Label, styles);

export { Label$1 as L };
